var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8331_1988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 9.99935H16.266C15.9018 9.99857 15.5474 10.1171 15.2569 10.3368C14.9665 10.5565 14.756 10.8653 14.6577 11.216L12.6993 18.1827C12.6867 18.226 12.6604 18.264 12.6243 18.291C12.5883 18.3181 12.5444 18.3327 12.4993 18.3327C12.4543 18.3327 12.4104 18.3181 12.3743 18.291C12.3383 18.264 12.312 18.226 12.2993 18.1827L7.69935 1.81602C7.68673 1.77274 7.66041 1.73473 7.62435 1.70768C7.58829 1.68064 7.54443 1.66602 7.49935 1.66602C7.45427 1.66602 7.41041 1.68064 7.37435 1.70768C7.33829 1.73473 7.31197 1.77274 7.29935 1.81602L5.34102 8.78268C5.24307 9.13198 5.03383 9.43978 4.74507 9.65936C4.4563 9.87894 4.10378 9.99831 3.74102 9.99935H1.66602",
    stroke: "#0C0C0C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8331_1988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsIcon);
export default __webpack_public_path__ + "static/media/logs-icon.696456d4401a6641c718f862448ce0ca.svg";
export { ForwardRef as ReactComponent };